import {
  Directive,
  HostBinding,
  HostListener,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import {openFileSelect} from '../utils/file.utils';
import {take} from 'rxjs';

@Directive({
  selector: '[covDragDropFiles]',
})
export class DragDropDirective {
  // INPUTS
  public allowedFileTypes: InputSignal<string | null> = input<string | null>(null);

  // OUTPUTS
  public filesDropped: OutputEmitterRef<FileList | null> = output();
  @HostBinding('class.dragover') isDragging = false;

  @HostListener('dragover', ['$event'])
  public onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  @HostListener('click')
  public onClick() {
    const whiteSpaceStripped = this.allowedFileTypes()?.replace(/\s+/g, '');
    openFileSelect(whiteSpaceStripped)
      .pipe(take(1))
      .subscribe((fileList) => this.filesDropped.emit(fileList));
  }

  @HostListener('dragleave')
  public onDragLeave() {
    this.isDragging = false;
  }

  @HostListener('drop', ['$event'])
  public onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
    if (event.dataTransfer?.files.length) {
      this.filesDropped.emit(event.dataTransfer.files);
    }
  }
}
